import { isEmail, isOnlyLetter, isRequired } from '../../../utils/validation';

export const initialValues = {
  name: '',
  email: '',
};

export const fieldsProps = {
  regional: {
    placeholder: 'Pilih Regional',
    label: 'Regional',
  },
  sam: {
    placeholder: 'Pilih SAM',
    label: 'SAM',
  },
  sbm: {
    placeholder: 'Pilih SBM',
    label: 'SBM',
  },
  name: {
    placeholder: 'Nama',
    label: 'Nama',
  },
  email: {
    placeholder: 'Email',
    label: 'Email',
  },
  role: {
    placeholder: 'Pilih Role',
    label: 'Role',
  },
};

export const validate = (values) => {
  const { name, email } = values;
  const rules = {
    name:
      isRequired(name, 'Nama harus diisi') ||
      isOnlyLetter(name, 'Nama hanya boleh diisi huruf'),
    email:
      isRequired(email, 'Email harus diisi') ||
      isEmail(email, 'Format email salah'),
  };

  return rules;
};
